<template>
    <div class="pad-admin-company">
      <div class="nav">
        <div class="title" @click="$router.replace({ path: '/' });">创建档案</div>
      </div>
      <div class="content">
        <div class="left">
          <div class="left-item" :class="{ active: active == 'info' || active == 'face' }">
            <div class="left-item-icon icon-1"></div>
            <div class="left-item-title">基本信息</div>
          </div>
          <div class="left-item" :class="{ active: active == 'services' || active == 'sign' }">
            <div class="left-item-icon icon-2"></div>
            <div class="left-item-title">服务内容</div>
          </div>
        </div>
        <div class="right">
            <div class="right-title">
              <div class="title" v-if="active == 'info'">基本信息</div>
              <div class="title" v-else-if="active == 'face'">人脸信息</div>
              <div class="title" v-else-if="active == 'services'">服务内容</div>
              <div class="title" v-else-if="active == 'sign'">签名信息</div>
            </div>

            <div class="right-content" v-if="active == 'info'">
                <div class="right-content-item">
                    <div class="right-content-item-title">姓名：</div>
                    <div class="right-content-item-content">
                        <input type="text" v-model="person.name" placeholder="请输入姓名"></input>
                    </div>
                </div>
                <div class="right-content-item">
                    <div class="right-content-item-title">手机号：</div>
                    <div class="right-content-item-content">
                        <input type="text" v-model="person.mobile" placeholder="请输入手机号"></input>
                    </div>
                </div>
                <div class="right-content-item">
                    <div class="right-content-item-title">身份证号：</div>
                    <div class="right-content-item-content">
                        <input type="text" v-model="person.idCard" placeholder="请输入身份证号"></input>
                    </div>
                </div>
            </div>

            <!-- 身份证感应区提示 - 屏幕底部居中 -->
            <div class="id-card-indicator" v-if="active == 'info'">
                <div class="indicator-text">
                    可把身份证放入感应区识别
                </div>
                <div class="indicator-arrow">
                    <svg width="80" height="80" viewBox="0 0 40 40" fill="none">
                        <path d="M20 25 L10 15 L15 15 L15 5 L25 5 L25 15 L30 15 Z" fill="#1FA4EB"/>
                    </svg>
                </div>
            </div>

            <div class="right-content" v-if="active == 'face'">
                <div class="face-camera">
                    <div class="camera-preview" :class="{ 'show-result': capturedImage }">
                        <video ref="video" autoplay playsinline></video>
                        <canvas ref="canvas" style="display: none;"></canvas>
                        <div class="camera-frame" v-if="!capturedImage && !loadingFaceDetection">
                            <div class="frame-corner corner-tl"></div>
                            <div class="frame-corner corner-tr"></div>
                            <div class="frame-corner corner-bl"></div>
                            <div class="frame-corner corner-br"></div>
                        </div>
                        <div class="camera-tips" v-if="!capturedImage && !loadingFaceDetection">请将面部对准框内</div>
                        <div class="camera-loading" v-if="loadingFaceDetection">
                            <div class="loading-spinner"></div>
                            <div class="loading-text">正在检测人脸...</div>
                        </div>
                        <div class="camera-result" v-if="capturedImage">
                            <img :src="capturedImage" alt="人脸照片">
                        </div>
                    </div>
                    <div class="camera-controls">
                        <div class="btn btn-retake" v-if="capturedImage || !hasFace" @click="retakePhoto">重新拍摄</div>
                        <div class="btn btn-capture" v-if="!capturedImage && !loadingFaceDetection" @click="capturePhoto">拍照</div>
                    </div>
                </div>
            </div>

            <div class="right-content" v-if="active == 'services'">
                <div class="service-list">
                    <div v-for="(item, index) in serviceList" :key="index" class="service-item">{{ (index + 1) + '、' + item.content }}</div>
                </div>
            </div>

            <div class="right-content" v-if="active == 'sign'">
                <div class="esign-view">
                    <div class="esign-btn">
                        <div class="btn" @click="handleReset">重写</div>
                        <div class="btn" @click="handleGenerate" v-if="!isCheck">确认</div>
                    </div>
                    <div class="esign-canvas">
                      <vue-esign ref="esign" :width="remToPx(5.66)" :height="remToPx(1.51)" :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" :bgColor.sync="bgColor" />
                    </div>
                    <div class="tips">请手写签字，笔画完成</div>
                </div>
            </div>

            <div class="step-control">
                <div class="btn btn-1" @click="prve()">{{ active == 'info' ? '取消' : '上一步' }}</div>
                <div class="btn btn-2" @click="next()">{{ active == 'sign' ? '提交' : '下一步' }}</div>
            </div>

        </div>
      </div>
    </div>
  </template>

  <script>
  import { getCompanyServices, createCompanyPerson } from '@api/index';
  import idleDetection from '@/mixins/idleDetection';
  import * as faceApi from 'face-api.js';

  export default {
    name: 'pad-admin-company',
    mixins: [idleDetection],
    data() {
      return {
        person : {
          idCard : '',
          mobile : '',
          name : '',
          cardInfo : {}
        },
        capturedImage: '',
        stream: null,
        isCheck : false,
        width : 800,
        height : 400,
        lineWidth: 6,
        lineColor: '#000000',
        bgColor: '#ffffff00',
        resultImg: '',
        isCrop: true,
        active: 'info',
        serviceList : [],
        // WebSocket相关属性
        ws: null,
        wsUrl: 'ws://127.0.0.1:24012',
        reconnectAttempts: 0,
        maxReconnectAttempts: 5,
        reconnectInterval: 3000,
        wsConnected: false,
        // 人脸检测相关
        modelsLoaded: false,
        loadingFaceDetection: false,
        hasFace: false,
        detectionInterval: null
      }
    },
    methods: {
      // 初始化WebSocket连接
      initWebSocket() {
        try {
          this.ws = new WebSocket(this.wsUrl);

          this.ws.onopen = () => {
            console.log('WebSocket连接已建立');
            this.wsConnected = true;
            this.reconnectAttempts = 0;
            // 发送身份证读取请求
            this.ws.send(JSON.stringify(
              {
                "module" : "idcard",
                "function" : "beginreadcard",
                "parameter": ""
              }
            ));
          };

          this.ws.onmessage = (event) => {
            try {
              const data = JSON.parse(event.data);
              if (data.ret == 0 && data.event && data.event == 'onreadcard') {
                this.person.cardInfo = data.Certificate;
                this.person.idCard = data.Certificate.IDNumber;
                this.person.name = data.Certificate.Name;
              }
            } catch (error) {
              console.error('解析WebSocket消息失败:', error);
            }
          };

          this.ws.onerror = (error) => {
            console.error('WebSocket错误:', error);
            this.wsConnected = false;
          };

          this.ws.onclose = (res) => {
            console.log('WebSocket连接已关闭', res);
            this.wsConnected = false;
            this.attemptReconnect();
          };
        } catch (error) {
          console.error('初始化WebSocket失败:', error);
          this.attemptReconnect();
        }
      },

      // WebSocket重连机制
      attemptReconnect() {
        if (this.reconnectAttempts < this.maxReconnectAttempts) {
          this.reconnectAttempts++;
          console.log(`正在尝试第${this.reconnectAttempts}次重连...`);
          setTimeout(() => {
            this.initWebSocket();
          }, this.reconnectInterval);
        } else {
          console.error('达到最大重连次数，停止重连');
          this.$dialog.toast({ mes: '身份证读取服务连接失败，请刷新页面重试' });
        }
      },

      // 关闭WebSocket连接
      closeWebSocket() {
        if (this.ws) {
          this.ws.close();
          this.ws = null;
          this.wsConnected = false;
        }
      },
      prve() {
        if (this.active == 'info') {
          this.$router.replace({ path: '/' });
        } else if (this.active == 'face') {
          this.stopCamera();
          this.capturedImage = '';
          this.hasFace = false;
          this.active = 'info'
          this.ws.send(JSON.stringify(
            {
              "module" : "idcard",
              "function" : "beginreadcard",
              "parameter": ""
            }
          ));
        } else if (this.active == 'services') {
          this.active = 'face';
          // 等待 DOM 更新后再初始化摄像头
          this.$nextTick(() => {
            this.initCamera();
          });
        } else if (this.active == 'sign') {
          this.$refs.esign.reset()
          this.isCheck = false
          this.resultImg = ''
          this.active = 'services'
        }
      },
      next() {
        let that = this;
        const phoneRegex = /^1[3-9]\d{9}$/;
        const idCardRegex = /(^\d{15}$)|(^\d{18}$)|(^\d{17}[\dXx]$)/;
        if (this.active == 'info') {
          if (!this.person.name) return this.$dialog.toast({ mes: "请填写姓名" });
          if (!this.person.mobile || !phoneRegex.test(this.person.mobile)) return this.$dialog.toast({ mes: "请填写有效手机号" });
          if (!this.person.idCard || !idCardRegex.test(this.person.idCard)) return this.$dialog.toast({ mes: "请填写有效身份证号码" });
          getCompanyServices().then(res => {
            that.serviceList = res.data;
            that.ws.send(JSON.stringify(
              {
                "module" : "idcard",
                "function" : "cancelreadcard",
                "parameter": ""
              }
            ));
            that.active = 'face';
            this.$nextTick(() => {
              this.initCamera();
            });
          }).catch(err => {
            return this.$dialog.toast({ mes: err.msg || '请求异常' });
          });
        } else if (this.active == 'face') {
          if (!this.capturedImage) return this.$dialog.toast({ mes: "请拍摄人脸照片" });
          if (!this.hasFace) return this.$dialog.toast({ mes: "照片中未检测到人脸，请重拍" });
          this.stopCamera();
          this.active = 'services'
        } else if (this.active == 'services') {
          this.active = 'sign';
        } else if (this.active == 'sign') {
          if (!this.resultImg) return this.$dialog.toast({ mes: "请签名" });
          this.submit();
        }
      },
      submit() {
        let that = this;
        let post = this.person;
        post.esign = this.resultImg;
        post.faceImage = this.capturedImage;
        createCompanyPerson(post).then(res => {
          that.$dialog.toast({ mes: '注册成功' });
          setTimeout(() => {
            that.$router.replace({ path: '/' });
          }, 1000);
        }).catch(err => {
          return that.$dialog.toast({ mes: err.msg || '请求异常' });
        });
      },
      handleReset () {
        this.isCheck = false;
        this.$refs.esign.reset()
      },
      handleGenerate () {
        this.$refs.esign.generate().then(res => {
          this.resultImg = res
          this.isCheck = true;
        }).catch(err => {
          return this.$dialog.toast({ mes: "请签名" });
        })
      },
      selectContent(type) {
        this.active = type
      },
      goPage(page) {
        if (page == '/padAdmin/shop') return this.$dialog.toast({ mes: "暂未开放" });
        this.$router.push({
          path: page
        })
      },
      remToPx(rem) {
        const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
        console.log(rootFontSize)
        return rem * rootFontSize;
        },
      initCamera() {
        // 如果摄像头已经在运行，不需要重新初始化
        if (this.stream) {
          console.log('摄像头已在运行，跳过初始化');
          return;
        }

        console.log('开始初始化摄像头...');

        const video = this.$refs.video;
        if (!video) {
          console.error('视频元素未找到，稍后重试');
          // 稍后重试
          setTimeout(() => {
            if (this.$refs.video) {
              this.initCamera();
            }
          }, 100);
          return;
        }

        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user', width: 640, height: 480 } })
            .then(stream => {
              console.log('摄像头获取成功');
              this.stream = stream;
              video.srcObject = stream;

              // 确保视频开始播放
              video.onloadedmetadata = () => {
                console.log('视频元数据加载完成');
                video.play().then(() => {
                  console.log('视频开始播放');
                }).catch(err => {
                  console.error('视频播放失败:', err);
                });
              };

              // 加载人脸检测模型
              this.loadFaceDetectionModels();
            })
            .catch(err => {
              console.error('无法访问摄像头:', err);
              this.$dialog.toast({ mes: '无法访问摄像头，请检查权限设置' });
            });
        } else {
          this.$dialog.toast({ mes: '您的浏览器不支持摄像头访问' });
        }
      },
      // 加载人脸检测模型
      async loadFaceDetectionModels() {
        if (this.modelsLoaded) return;

        try {
          await Promise.all([
            faceApi.nets.tinyFaceDetector.loadFromUri('/models'),
            faceApi.nets.faceLandmark68Net.loadFromUri('/models'),
            faceApi.nets.faceRecognitionNet.loadFromUri('/models'),
          ]);
          this.modelsLoaded = true;
          console.log('人脸检测模型加载成功');
        } catch (error) {
          console.error('人脸检测模型加载失败:', error);
        }
      },
      capturePhoto() {
        const video = this.$refs.video;
        const canvas = this.$refs.canvas;
        const context = canvas.getContext('2d');

        // 重置状态，防止使用旧的检测结果
        this.hasFace = false;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        const imageData = canvas.toDataURL('image/jpeg');

        // 检测人脸
        this.detectFace(imageData);
      },
      // 检测人脸
      async detectFace(imageData) {
        this.loadingFaceDetection = true;

        try {
          // 将 base64 转换为 HTMLImageElement
          const img = await this.loadImage(imageData);

          // 检测人脸，设置更高的置信度阈值（0.5 -> 0.6）以提高准确性
          const detections = await faceApi
            .detectAllFaces(img, new faceApi.TinyFaceDetectorOptions({
              inputSize: 416,
              scoreThreshold: 0.6  // 提高置信度阈值，减少误检
            }))
            .withFaceLandmarks();

          // 判断是否检测到人脸
          this.hasFace = detections.length > 0;

          if (this.hasFace) {
            this.capturedImage = imageData;
            this.$dialog.toast({ mes: `检测到人脸`, timeout: 1500 });
            console.log('人脸检测成功，检测到', detections.length, '张人脸');
          } else {
            this.capturedImage = ''; // 确保没有保存无人脸的照片
            this.$dialog.toast({ mes: '未检测到人脸，请重拍', timeout: 2000 });
            console.log('未检测到人脸');
          }
        } catch (error) {
          console.error('人脸检测失败:', error);
          this.hasFace = false; // 明确设置为 false
          this.capturedImage = ''; // 清空照片
          this.$dialog.toast({ mes: '人脸检测失败，请重试', timeout: 2000 });
        } finally {
          this.loadingFaceDetection = false;
        }
      },
      // 加载图片
      loadImage(src) {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => resolve(img);
          img.onerror = reject;
          img.src = src;
        });
      },
      retakePhoto() {
        // 清空照片和状态
        this.capturedImage = '';
        this.hasFace = false;
        this.loadingFaceDetection = false;
        console.log('重置拍照状态');

        // 如果摄像头没有运行，重新启动
        if (!this.stream) {
          console.log('摄像头未运行，重新启动');
          this.$nextTick(() => {
            this.initCamera();
          });
        }
      },
      stopCamera() {
        if (this.stream) {
          this.stream.getTracks().forEach(track => {
            track.stop();
            console.log('摄像头轨道已停止');
          });
          this.stream = null;
        }

        // 清理视频元素的 srcObject
        const video = this.$refs.video;
        if (video) {
          if (video.srcObject) {
            video.srcObject.getTracks().forEach(track => track.stop());
            video.srcObject = null;
          }
        }

        // 清理人脸检测定时器
        if (this.detectionInterval) {
          clearInterval(this.detectionInterval);
          this.detectionInterval = null;
        }

        console.log('摄像头已停止');
      }
    },
    mounted() {
      this.initWebSocket();
    },
    beforeDestroy() {
      this.stopCamera();
      this.closeWebSocket();
    }
  }
  </script>

  <style scoped  lang="scss">
  .pad-admin-company {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  padding: 70px 40px 0;
  display: flex;
  flex-direction: column;

  .nav {
    font-family: 'YouSheBiaoTiHei';
    color: #FFFFFF;
    font-weight: 400;
    font-size: 48px;
    margin-bottom: 40px;
    position: relative;

    .title {
      display: inline-block;
      padding: 8px 44px 0;
      cursor: pointer;

      &::before {
        content: '';
        width: 25px;
        height: 25px;
        border-top: 4px solid transparent;
        border-bottom: 4px solid #fff;
        border-right: 4px solid transparent;
        border-left: 4px solid #fff;
        position: absolute;
        top: 50%;
        left: 0;
        transform: rotate(45deg) translateY(-50%);
      }
    }
  }

    .content {
      display: flex;
      margin-top: 48px;

      .left {
        background: linear-gradient(180deg, #0066cc, transparent);
        width: 260px;
        height: 768px;
        border-radius: 0rem 16px 16px 16px;
        opacity: 0.9;
        display: flex;
        flex-wrap: wrap;
        align-content: center;


        .left-item {
          width: 100%;
          height: 108px;
          font-weight: 600;
          font-size: 30px;
          color: #FFFFFF;
          line-height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 84px;

          .left-item-icon {
            width: 29px;
            height: 29px;
            background-size: 100%;

            &.icon-1 {
              background-image: url("../../assets/images/left-icon-1.png");
            }

            &.icon-2 {
              background-image: url("../../assets/images/left-icon-2.png");
            }

            &.icon-3 {
              background-image: url("../../assets/images/left-icon-3.png");
            }

            &.icon-4 {
              background-image: url("../../assets/images/left-icon-4.png");
            }

          }

          .left-item-title {
            margin-left: 19px;
          }

          &.active {
            background: #1FA4EB;
            border-radius: 0rem 10px 10px 0rem;
          }
        }
      }

      .right {
        background: linear-gradient(180deg, #0066cc, transparent);
        flex: 1;
        margin-left: 40px;
        height: 768px;
        border-radius: 20px;
        position: relative;

        .right-title {
            font-weight: 600;
            font-size: 36px;
            color: #FFFFFF;
            line-height: 116px;
            height: 116px;
            text-align: center;
            border-bottom: 1px solid #1FA4EB;
        }

        .right-content {
            padding-top: 29px;


            .service-list {
                height: 480px;
                margin: 0 auto;
                overflow: scroll;
                padding: 0 20px;

                .service-item {
                    font-weight: 400;
                    font-size: 26px;
                    color: #FFFFFF;
                    line-height: 44px;

                    &:first-child {
                        margin-top: 32px;
                    }
                }
            }

            .esign-view {
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;

                .esign-canvas {
                  background-color: #FFFFFF;
                  border-radius: 20px;
                }

                canvas {
                  border-radius: 20px;
                }

                .tips {
                    margin-top: 30px;
                    font-weight: 400;
                    font-size: 26px;
                    color: #FFFFFF;
                    line-height: 44px;
                }
            }


            .right-content-item {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 50px;

                .right-content-item-title {
                    font-weight: 500;
                    font-size: 28px;
                    color: #FFFFFF;
                    line-height: 36px;
                    width: 160px;
                    text-align: right;
                    margin-right: 20px;
                    position: relative;

                    &::before {
                        content: '*';
                        position: absolute;
                        top: 0;
                        transform: translateX(-20px);
                        color: red;
                    }
                }


                .right-content-item-content {
                    width: 480px;
                    height: 80px;
                    input {
                        display: block;
                        width: inherit;
                        height: inherit;
                        padding: 24px;
                        color: #fff;
                        font-size: 26px;
                        background: #033172e6;
                        border-radius: 20px;
                    }
                }

            }

            .face-camera {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 20px;

                .camera-preview {
                    position: relative;
                    width: 480px;
                    height: 360px;
                    background-color: #000;
                    border-radius: 20px;
                    overflow: hidden;

                    video {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transition: opacity 0.3s ease;
                    }

                    &.show-result {
                        video {
                            opacity: 0;
                            pointer-events: none;
                        }
                    }

                    .camera-frame {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 280px;
                        height: 280px;
                        border: 2px dashed rgba(255, 255, 255, 0.6);

                        .frame-corner {
                            position: absolute;
                            width: 40px;
                            height: 40px;
                            border-color: #1FA4EB;
                            border-style: solid;
                            border-width: 4px;

                            &.corner-tl {
                                top: -4px;
                                left: -4px;
                                border-right: none;
                                border-bottom: none;
                            }

                            &.corner-tr {
                                top: -4px;
                                right: -4px;
                                border-left: none;
                                border-bottom: none;
                            }

                            &.corner-bl {
                                bottom: -4px;
                                left: -4px;
                                border-right: none;
                                border-top: none;
                            }

                            &.corner-br {
                                bottom: -4px;
                                right: -4px;
                                border-left: none;
                                border-top: none;
                            }
                        }
                    }

                    .camera-tips {
                        position: absolute;
                        bottom: 20px;
                        left: 50%;
                        transform: translateX(-50%);
                        font-size: 20px;
                        color: #FFFFFF;
                        background-color: rgba(0, 0, 0, 0.5);
                        padding: 8px 16px;
                        border-radius: 10px;
                    }

                    .camera-loading {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(0, 0, 0, 0.7);
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        z-index: 20;

                        .loading-spinner {
                            width: 50px;
                            height: 50px;
                            border: 4px solid rgba(255, 255, 255, 0.3);
                            border-top-color: #1FA4EB;
                            border-radius: 50%;
                            animation: spin 1s linear infinite;
                        }

                        .loading-text {
                            margin-top: 20px;
                            font-size: 20px;
                            color: #FFFFFF;
                        }
                    }

                    @keyframes spin {
                        to {
                            transform: rotate(360deg);
                        }
                    }
                }

                .camera-result {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: #000;
                    border-radius: 20px;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 10;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                .camera-controls {
                    margin-top: 30px;
                    display: flex;
                    justify-content: center;
                    gap: 20px;

                    .btn {
                        width: 160px;
                        height: 60px;
                        border-radius: 20px;
                        font-size: 24px;
                        color: #FFFFFF;
                        line-height: 60px;
                        text-align: center;
                        cursor: pointer;
                        opacity: 0.9;

                        &.btn-capture {
                            background-color: #1FA4EB;
                        }

                        &.btn-retake {
                            background-color: #013A82;
                        }
                    }
                }
            }
        }

        .step-control {
            position: absolute;
            bottom: 74px;
            text-align: center;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            display: flex;
            justify-content: space-evenly;
            .btn {
                text-align: center;
                width: 180px;
                height: 80px;
                border-radius: 20px;
                opacity: 0.9;
                font-weight: 500;
                font-size: 30px;
                color: #FFFFFF;
                line-height: 80px;
                display: inline-block;
                &.btn-1 {background: #013A82;}
                &.btn-2 {background: #1FA4EB;}
            }
        }

        // 身份证感应区提示样式
        .id-card-indicator {
            position: fixed;
            bottom: 60px;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            z-index: 1000;

            .indicator-text {
                font-weight: 400;
                font-size: 44px;
                color: #1FA4EB;
                line-height: 36px;
                margin-bottom: 10px;
                animation: pulse 2s ease-in-out infinite;
            }

            .indicator-arrow {
                animation: bounce 1.5s ease-in-out infinite;

                svg {
                    filter: drop-shadow(0 2px 4px rgba(31, 164, 235, 0.3));
                }
            }
        }

        @keyframes pulse {
            0%, 100% {
                opacity: 0.6;
                transform: scale(1);
            }
            50% {
                opacity: 1;
                transform: scale(1.05);
            }
        }

        @keyframes bounce {
            0%, 100% {
                transform: translateY(0);
            }
            50% {
                transform: translateY(10px);
            }
        }
      }
    }

    .esign-btn {
      display: flex;
      margin-bottom: 29px;

      .btn {
        background-color: #1FA4EB;
        text-align: center;
        width: 120px;
        height: 60px;
        border-radius: 20px;
        opacity: 0.9;
        font-weight: 500;
        font-size: 24px;
        color: #FFFFFF;
        line-height: 60px;
        display: inline-block;
        margin: 0 100px;
      }
    }
  }
  </style>
